import React from 'react'
import { withRouter } from 'react-router-dom'

import Alert from 'components/Alert'
import Button from 'components/Button'
import FieldWithInput from 'components/FieldWithInput'
import FormFooter from 'components/FormFooter'
import Input from 'components/Input'
import paths from 'constants/paths'
import { auth, db } from 'data'
import assertions from 'utils/assertions'

const INITIAL_STATE = {
  email: '',
  emailValid: false,
  error: null,
  password: '',
  passwordValid: false,
  submitting: false,
}

export class SignUpForm extends React.Component {
  state = { ...INITIAL_STATE }

  clearError = () => { // eslint-disable-line react/sort-comp
    this.setState({ error: null })
  }

  clearForm = () => {
    this.setState({ ...INITIAL_STATE })
  }

  setError = (error) => {
    this.setState({ error })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { history } = this.props
    const { email, password } = this.state

    this.clearError()

    // firebase auth
    auth.signUp(email, password)
      .then((user) => {
        console.log('signed up')

        // firebase db
        db.createUser(user.uid, email)
          .then(() => {
            console.log('user created')

            this.clearForm()

            //history.push(paths.HOME)
            history.push(paths.REPORTS)
          })
          .catch((error) => {
            console.log(error)
            this.setError(error)
          })
      })
      .catch((error) => {
        console.log(error)
        this.setError(error)
      })
  }

  render() {
    const {
      emailValid, error, passwordValid, submitting,
    } = this.state

    return (
      <form className="SignUpForm" onSubmit={this.handleSubmit}>
        {/*
        <FieldWithInput
          input={Input}
          inputProps={{
            icon: 'lock',
          }}
          label="Invite code"
          labelAsPlaceholder
        />
        */}
        <FieldWithInput
          input={Input}
          inputProps={{
            type: 'email',
            autoComplete: 'username email',
            name: 'email',
            icon: 'user',
            onFocus: this.clearError,
          }}
          label="Email"
          labelAsPlaceholder
          validate={(e) => assertions.email(e.target.value)}
          onInvalidChange={() => this.setState({ emailValid: false })}
          onValidChange={(e) =>
            this.setState({
              email: e.target.value,
              emailValid: true,
            })
          }
        />
        <FieldWithInput
          input={Input}
          inputProps={{
            type: 'password',
            autoComplete: 'new-password',
            name: 'password',
            icon: 'lock',
            onFocus: this.clearError,
          }}
          label="Password"
          labelAsPlaceholder
          validate={(e) => assertions.notEmpty(e.target.value)}
          onInvalidChange={() => this.setState({ passwordValid: false })}
          onValidChange={(e) =>
            this.setState({
              password: e.target.value,
              passwordValid: true,
            })
          }
        />
        <FormFooter>
          <Button
            type="submit"
            disabled={!emailValid || !passwordValid || submitting}
            full
            onClick={this.handleSubmit}>
            Create account
          </Button>
        </FormFooter>
        {error &&
          <Alert>
            {error.message}
          </Alert>
        }
      </form>
    )
  }
}

export default withRouter(SignUpForm)



// WEBPACK FOOTER //
// ./src/components/SignUpForm/SignUpForm.js